import { render } from "./TeamTrial.vue?vue&type=template&id=c8455842"
import script from "./TeamTrial.vue?vue&type=script&lang=js"
export * from "./TeamTrial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__